import { Component, OnInit } from '@angular/core';
import { GlobalFunctions } from './content/libs/global-functions';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
  title = 'app';
  hash: string = undefined;
  scrollDuration = 500;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.getHash() != undefined && this.getHash().trim().length > 0) {
          this.scrollToElement('#' + this.getHash(), this.scrollDuration);
        }
      }
    });
    this.route.fragment.subscribe((fragment: string) => {
      this.hash = fragment;
    })
  }

  ngOnInit(): void {
    // scroll up on route change
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0);
    });
  }

  getHash(): string {
    return this.hash;
  }

  public scrollToElement(id: string, duration: number): void {
    GlobalFunctions.scrollToElement(id, duration);
  }
  public goToTwitter(){
    this.openTab('https://twitter.com/Warpriders_');
  }
  public goToInstagram(){
    this.openTab('https://www.instagram.com/warpriders_miniature_painting/');
  }
  public goToFacebook(){
    this.openTab('https://facebook.com/Warpriders-Miniature-Painting-Service-140537793358121');
  }
  private openTab(url: string) {
    window.open(url, '_blank');

  }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/app.component.ts